import { Component } from '@angular/core';

@Component({
  selector: 'app-suspicious-activity',
  templateUrl: './suspicious-activity.component.html',
  styleUrls: ['./suspicious-activity.component.css']
})
export class SuspiciousActivityComponent {
  
}
